import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import _ from "lodash";

import { PageWrapper, Loader, Alert, Pagination } from "../../components";
import Actions, { thunks } from "../../redux/modules/products";
import DiscountModal from "./components/discountModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import AddProductModal from "./components/addProduct";

class Products extends React.Component {
  state = {
    toApplyDiscount: {},
    // parentCategoryIdValue: "",
  };

  componentDidMount() {
    const { dispatch, parentCategoryID } = this.props;
    if (parentCategoryID) dispatch(thunks.getCategories(parentCategoryID));
    else dispatch(thunks.getCategories());
  }

  viewProduct = (product) => {
    this.props.history.push(`/product/${product.productId}`);
  };
  onStatusChange = (e, id) => {
    console.log("Produt data", id, e);
    const { dispatch } = this.props;
    let items = this.props.list;
    let item = items.find((o) => o.productId === id);
    item.status = e ? 1 : 0;
    // this.setState({ list: items });
    const body = {
      status: e ? 1 : 0,
    };
    dispatch(thunks.changeProductStatus(body, id));
  };
  onSeqNumberChange = (e, id) => {
    const { dispatch } = this.props;
    let items = this.props.list;
    let item = items.find((o) => o.productId === id);
    item.seq_no = e.target.value;
    const body = {
      seq_no: e.target.value,
    };
    dispatch(thunks.changeProductStatus(body, id));
  };

  ontagChange = (e, id) => {
    const { dispatch } = this.props;
    let items = this.props.list;
    let item = items.find((o) => o.productId === id);
    item.tag = e.target.value;
    const body = {
      tag: e.target.value,
    };
    dispatch(thunks.changeProductStatus(body, id));
  };

  onNext = () => {
    const { dispatch } = this.props;
    dispatch(thunks.loadMoreProducts());
  };

  onSearchTextChange = _.debounce((e) => {
    const { value } = e.target ? e.target : "";
    const { updateProperty, dispatch } = this.props;
    updateProperty("searchText", value);
    if (value) {
      dispatch(thunks.searchProducts(value));
    }
  }, 300);

  onCategoryChange = (e) => {
    const { value } = e.target;
    const { updateProperty, dispatch } = this.props;
    // this.setState({parentCategoryIdValue:value})
    updateProperty("parentCategoryID", value);
    dispatch(thunks.getCategories(value));
  };

  onSubCategoryChange = (e) => {
    const { updateProperty, dispatch } = this.props;
    updateProperty("parentSubCategoryID", e.target.value);
    dispatch(thunks.getProducts());
  };

  onAddProducts = (data) => {
    const { dispatch } = this.props;
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    dispatch(thunks.addProducts(formData));
    this.closeModal();
  };

  onAppyDiscount = (product) => {
    this.setState({ toApplyDiscount: product });
    console.log(this.state.toApplyDiscount);
  };

  onHideDiscountModal = () => {
    this.setState({ toApplyDiscount: {} });
  };

  handleApplyDiscount = (discount) => {
    const { dispatch } = this.props;
    const { toApplyDiscount } = this.state;
    dispatch(
      thunks.applyDisccount({
        discount,
        id: toApplyDiscount.productId,
      })
    );
    this.onHideDiscountModal();
  };

  handleAddversion = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", true);
  };

  closeModal = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", false);
  };

  handleDeleteProduct = (id) => {
    const { dispatch } = this.props;
    dispatch(thunks.deleteProduct(id));
  };

  render() {
    const {
      list,
      loading,
      error,
      updateProperty,
      nextPageToken,
      totalCount,
      categories,
      subCategories,
      parentCategoryID,
      parentSubCategoryID,
      message,
      showModal,
    } = this.props;
    const { toApplyDiscount } = this.state;
    let sampleObj = {
      array: [],
    };
    for (var l = 1; l <= totalCount; l++) {
      sampleObj.array[l] = l;
    }
    let optionItems = sampleObj.array.map((item) => (
      <option key={item}>{item}</option>
    ));

    let tags = ["new", "popular"];
    let tagItems = tags.map((item) => <option key={item}>{item}</option>);

    return (
      <PageWrapper title="Product List">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Products"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Category</label>
                        <select
                          className="form-control"
                          value={parentCategoryID}
                          onChange={this.onCategoryChange}
                        >
                          {categories.map((category) => (
                            <option key={category.id} value={category.id}>
                              {category.displayName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {!!subCategories.length && (
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Subcategory</label>
                          <select
                            className="form-control"
                            value={parentSubCategoryID}
                            onChange={this.onSubCategoryChange}
                          >
                            {subCategories.map((category) => (
                              <option key={category.id} value={category.id}>
                                {category.displayName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Search</label>
                        <input
                          placeholder="Enter product title"
                          className="form-control"
                          onChange={this.onSearchTextChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mb-3">
                    <button
                      className="btn btn-primary"
                      onClick={this.handleAddversion}
                    >
                      <i className="fa fa-plus" />
                      Add
                    </button>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product Title</th>
                          <th>Category</th>
                          <th className="text-center">Stock</th>
                          <th>seq No</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((product) => (
                            <tr key={product.productId}>
                              <td>{product.productId}</td>
                              <td>{product.title}</td>
                              <td>
                                {(
                                  categories.find(
                                    (category) =>
                                      category.id === product.parentCategoryId
                                  ) || {}
                                ).displayName || "-"}
                              </td>
                              <td className="text-center">
                                <span
                                  className={classNames("badge badge-success", {
                                    // 'badge-success': product.inStock,
                                    // 'badge-danger': !product.inStock
                                  })}
                                >
                                  {/* {!product.inStock && 'Not '}Available */}
                                  Available
                                </span>
                              </td>
                              <td>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    this.onSeqNumberChange(e, product.productId)
                                  }
                                  value={product.seq_no}
                                >
                                  {optionItems}
                                </select>{" "}
                              </td>
                              <td>
                                {/* new***** Popular */}
                                <div>
                                  <select
                                    className="form-control text-primary font-weight-bold"
                                    onChange={(e) =>
                                      this.ontagChange(e, product.productId)
                                    }
                                    value={product.tag}
                                  >
                                    <option value="none">--Select--</option>
                                    {tagItems}
                                  </select>
                                </div>
                              </td>
                              <td>
                                <button
                                  title="View Product"
                                  className="btn btn-xs btn-info"
                                  onClick={() => this.viewProduct(product)}
                                >
                                  <i className="fa fa-eye" />
                                </button>
                                <button
                                  title="Add To Hotlook"
                                  className="btn btn-xs btn-primary ml-2"
                                  onClick={() => this.onAppyDiscount(product)}
                                >
                                  <i className="fa fa-plus" />
                                </button>
                                <span className="ml-2">
                                  <BootstrapSwitchButton
                                    checked={product.status === 1}
                                    onstyle="success"
                                    offstyle="danger"
                                    size="xs"
                                    onChange={(e) =>
                                      this.onStatusChange(e, product.productId)
                                    }
                                  />
                                </span>
                                <button
                                  title="Delete Product"
                                  className="btn btn-xs btn-danger ml-2"
                                  onClick={() =>
                                    this.handleDeleteProduct(product.productId)
                                  }
                                >
                                  <i className="fa fa-trash" />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    nextPageToken={nextPageToken}
                    onNext={this.onNext}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <DiscountModal
          show={!isEmpty(toApplyDiscount)}
          data={toApplyDiscount}
          onHide={this.onHideDiscountModal}
          handleApplyDiscount={this.handleApplyDiscount}
        />
        <Alert
          show={!!message}
          onHide={() => updateProperty("message", "")}
          title="Products"
          message={message}
        />
        <AddProductModal
          show={showModal}
          categories={categories}
          subCategories={subCategories}
          parentCategoryID={parentCategoryID}
          parentSubCategoryID={parentSubCategoryID}
          onCategoryChange={this.onCategoryChange}
          onSubCategoryChange={this.onSubCategoryChange}
          onHide={this.closeModal}
          addVersion={this.addVersion}
          onAddProducts={this.onAddProducts}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  products: {
    loading,
    error,
    list,
    nextPageToken,
    totalCount,
    categories,
    subCategories,
    parentCategoryID,
    parentSubCategoryID,
    message,
    showModal,
  },
}) => ({
  loading,
  error,
  list,
  nextPageToken,
  totalCount,
  categories,
  subCategories,
  parentCategoryID,
  parentSubCategoryID,
  message,
  showModal,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
